const key = Symbol.for("@openDAW/lib-dsp");
if (globalThis[key]) {
    console.debug(`%c${key.description}%c is already available in ${globalThis.constructor.name}.`, "color: hsl(10, 83%, 60%)", "color: inherit");
}
else {
    globalThis[key] = true;
    console.debug(`%c${key.description}%c is now available in ${globalThis.constructor.name}.`, "color: hsl(200, 83%, 60%)", "color: inherit");
}
export * from "./AudioBuffer";
export * from "./bpm-tools";
export * from "./biquad-coeff";
export * from "./biquad-processor";
export * from "./crusher";
export * from "./chords";
export * from "./constants";
export * from "./delay";
export * from "./events";
export * from "./fft";
export * from "./functions";
export * from "./fractions";
export * from "./fragmentor";
export * from "./graph";
export * from "./grooves";
export * from "./midi-keys";
export * from "./notes";
export * from "./osc";
export * from "./ppqn";
export * from "./ramp";
export * from "./resampler";
export * from "./rms";
export * from "./stereo";
export * from "./utils";
export * from "./value";
export * from "./window";
